import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import authReducer from "./slice/authSlice";
import rolesReducer from "./slice/rolesSlice";
import configurationReducer from "./slice/configurationSlice";
import usersReducer from "./slice/usersSlice";
import personReducer from "./slice/personSlice";
import productReducer from "./slice/productSlice";
import packageReducer from "./slice/packageSlice";
import leadsReducer from "./slice/leadSlice";
import branchReducer from "./slice/branchSlice";
import followupReducer from "./slice/followupSlice";
import notificationReducer from "./slice/notificationSlice";
import customerReducer from "./slice/customerSlice";
import trackingReducer from "./slice/trackingSlice";
import quotationReducer from "./slice/quotationSlice";
import dashboardReducer from "./slice/dashboardSlice";
import organizationReducer from "./slice/organizationSlice";
import monitoringReducer from "./slice/monitoringSlice";
import reportReducer from "./slice/reportSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  roles: rolesReducer,
  configuration: configurationReducer,
  users: usersReducer,
  persons: personReducer,
  customers: customerReducer,
  products: productReducer,
  packages: packageReducer,
  leads: leadsReducer,
  branches: branchReducer,
  followups: followupReducer,
  quotations: quotationReducer,
  dashboard: dashboardReducer,
  notifications: notificationReducer,
  tracking: trackingReducer,
  organizations: organizationReducer,
  monitoring: monitoringReducer,
  reports: reportReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
